export const SET_CITIES = 'SET_CITIES'
export const FETCH_CITIES_REQUEST = 'FETCH_CITIES_REQUEST'
export const FETCH_CITIES_SUCCES = 'FETCH_CITIES_SUCCES'
export const FETCH_CITIES_ERROR = 'FETCH_CITIES_ERROR'



// WEBPACK FOOTER //
// ./src/constants/Cities.js